module.exports = __webpack_public_path__ + "static/media/profile-icon.0c9e88ef.png";